module.exports = {
    default: true,
    header: 'Honesty statement',
    text:
        "I, [candidate's name], certify that I'm answering as myself, the answers in my application are my own and not plagiarised or written by any other individual, nor were they automatically generated using any software.",
}
